var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { PublicKey } from "@solana/web3.js";
import { findOrCreateAta } from "./findOrCreateAta.function";
import { Metaplex } from "@metaplex-foundation/js";
import { createUmi } from "@metaplex-foundation/umi-bundle-defaults";
import { dasApi } from "@metaplex-foundation/digital-asset-standard-api";
import { fetchAsset } from "@metaplex-foundation/mpl-core";
import { whichStandard } from "./findNftDataAndAccounts.function";
export function getCreatorData(_a) {
    return __awaiter(this, arguments, void 0, function (_b) {
        var instructions, ownerAta, creators, creatorTokenAta, shares, creatorsList, metaplex, nftData, umi, coreCollectionData, mintAtaList, display;
        var _this = this;
        var connection = _b.connection, nftMint = _b.nftMint, owner = _b.owner, paymentMint = _b.paymentMint, signer = _b.signer, tokenStandard = _b.tokenStandard;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    instructions = [];
                    return [4 /*yield*/, findOrCreateAta({
                            connection: connection,
                            mint: paymentMint,
                            owner: owner,
                            signer: signer,
                        })];
                case 1:
                    ownerAta = (_c.sent()).mintAta;
                    if (!!tokenStandard) return [3 /*break*/, 3];
                    return [4 /*yield*/, whichStandard({ connection: connection, mint: nftMint })];
                case 2:
                    tokenStandard = _c.sent();
                    _c.label = 3;
                case 3:
                    if (tokenStandard === "hybrid") {
                        console.log(tokenStandard, "nftMint", nftMint);
                        throw "not supported for hybrid nfts";
                    }
                    creators = [signer, signer, signer, signer, signer];
                    creatorTokenAta = [ownerAta, ownerAta, ownerAta, ownerAta, ownerAta];
                    shares = [0, 0, 0, 0, 0];
                    creatorsList = [];
                    if (!(tokenStandard === "native")) return [3 /*break*/, 5];
                    metaplex = new Metaplex(connection);
                    return [4 /*yield*/, metaplex.nfts().findByMint({ mintAddress: new PublicKey(nftMint) })];
                case 4:
                    nftData = _c.sent();
                    creatorsList = nftData.creators.map(function (c) {
                        return { address: c.address.toString(), share: c.share };
                    });
                    return [3 /*break*/, 7];
                case 5:
                    console.log(nftMint, "tokenStandard", tokenStandard);
                    umi = createUmi(connection.rpcEndpoint).use(dasApi());
                    return [4 /*yield*/, fetchAsset(umi, nftMint)];
                case 6:
                    coreCollectionData = _c.sent();
                    if (coreCollectionData.royalties) {
                        creatorsList = coreCollectionData.royalties.creators.map(function (c) {
                            return { address: c.address, share: c.percentage };
                        });
                    }
                    _c.label = 7;
                case 7:
                    mintAtaList = [];
                    return [4 /*yield*/, Promise.all(creatorsList.map(function (c, i) { return __awaiter(_this, void 0, void 0, function () {
                            var ataData;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        creators[i] = c.address.toString();
                                        return [4 /*yield*/, findOrCreateAta({
                                                connection: connection,
                                                mint: paymentMint,
                                                owner: c.address.toString(),
                                                signer: signer,
                                            })];
                                    case 1:
                                        ataData = _a.sent();
                                        if (ataData.instruction && !mintAtaList.includes(ataData.mintAta.toString())) {
                                            instructions.push(ataData.instruction);
                                            mintAtaList.push(ataData.mintAta.toString());
                                        }
                                        creatorTokenAta[i] = ataData.mintAta;
                                        shares[i] = c.share;
                                        return [2 /*return*/];
                                }
                            });
                        }); }))];
                case 8:
                    _c.sent();
                    console.log("creators", creators
                        .map(function (c, i) {
                        if (c == signer)
                            return undefined;
                        return { address: c, ata: creatorTokenAta[i], share: shares[i] };
                    })
                        .filter(function (c) { return c; }));
                    return [2 /*return*/, {
                            instructions: instructions,
                            creators: creators,
                            creatorTokenAta: creatorTokenAta,
                            tokenStandard: tokenStandard,
                            shares: shares,
                        }];
            }
        });
    });
}
